import { render, staticRenderFns } from "./Daftar.vue?vue&type=template&id=7bb9cc5a&"
import script from "./Daftar.vue?vue&type=script&lang=js&"
export * from "./Daftar.vue?vue&type=script&lang=js&"
import style0 from "./Daftar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports